import { http, HttpResponse } from 'msw';

import { eligibleCreditCardsMock1 } from '../data/kbWallet';
import { v4Resource } from '../helpers';

export const kbWalletHandlers = [
    http.get(v4Resource('/wallets/eligible-credit-cards'), async () => {
        return HttpResponse.json(eligibleCreditCardsMock1);
    }),
    http.get(v4Resource('/wallets/credit-cards'), async () => {
        return HttpResponse.json(eligibleCreditCardsMock1);
    }),
];
